import axios from "axios"

const baseURL = `${process.env.APP_BASE}/api/v1`

const instance = axios.create({
    timeout: 30000, // timeout - 30s
    baseURL,
})
instance.defaults.headers.post["Content-Type"] = "application/json"

const refreshToken = (refreshTokenLocal) => {
    if (refreshTokenLocal) {
        return instance.post(`/auth/refresh-token`, { originalRefreshToken: refreshTokenLocal }, {})
    }
    return Promise.reject(new Error("no refresh Token"))
}
instance.interceptors.request.use(
    (config) => {
        let accessToken
        if (config.passwordToken) {
            accessToken = config.passwordToken
        } else if (config.verificationToken) {
            accessToken = config.verificationToken
        } else {
            accessToken = JSON.parse(localStorage.getItem("accessToken"))
        }
        config.headers.Authorization = accessToken ? `Bearer ${accessToken}` : ""
        if (config.url.includes("/files/")) {
            config.headers["Content-Type"] = "multipart/form-data"
        }
        return config
    },
    (error) => {
        return Promise.reject(error.response)
    }
)
let isRefreshing = false
let refreshSubscribers = []
instance.interceptors.response.use(
    (response) => {
        if (response.data.status === 0) {
            return response.data
        }
        return Promise.reject(response.data.message)
    },
    (error) => {
        if (!error.response) {
            if (error.code === "ECONNABORTED") {
                error.message = "Request Timeout"
                return Promise.reject(error)
            }
            return Promise.reject(error)
        }
        if (error.response) {
            if (error.response.status === 401 && error.response.data.code === "AccessTokenInvalid") {
                const { config } = error
                let refreshTokenLocal = null
                if (window.localStorage.getItem("refreshToken") !== "undefined") {
                    refreshTokenLocal = JSON.parse(window.localStorage.getItem("refreshToken"))
                }
                if (!isRefreshing) {
                    isRefreshing = true
                    return refreshToken(refreshTokenLocal)
                        .then((res) => {
                            const newAccessToken = res.data.token
                            const newRefreshToken = res.data.refreshToken
                            localStorage.setItem("accessToken", JSON.stringify(newAccessToken))
                            localStorage.setItem("refreshToken", JSON.stringify(newRefreshToken))
                            config.headers.Authorization = `Bearer ${newAccessToken}`
                            refreshSubscribers.forEach((cb) => cb(newAccessToken))
                            refreshSubscribers = []
                            return instance(config)
                        })
                        .catch((err) => {
                            localStorage.removeItem("accessToken")
                            localStorage.removeItem("userInfo")
                            localStorage.removeItem("refreshToken")
                            window.location.replace("/")
                            return Promise.reject(err)
                        })
                        .finally(() => {
                            isRefreshing = false
                        })
                }
                return new Promise((resolve) => {
                    refreshSubscribers.push((token) => {
                        config.headers.Authorization = `Bearer ${token}`
                        resolve(instance(config))
                    })
                })
            }
            if (error.response.status === 504) {
                error.response.data = { data: { message: "Error on Request Sending. App server crashed" } }
            }
            return Promise.reject(error.response.data)
        }
        return Promise.reject(error.response.data)
    }
)

export const requestGet = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "get",
            url,
            params,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestPost = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "post",
            url,
            data,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestPut = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "put",
            url,
            data,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestPatch = (url, data, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "patch",
            url,
            data,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const requestDelete = (url, params, config = {}) => {
    return new Promise((resolve, reject) => {
        instance({
            method: "delete",
            url,
            params,
            ...config,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
